import { render, staticRenderFns } from "./dataImport.vue?vue&type=template&id=4bebcdac&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./dataImport.vue?vue&type=script&lang=js&"
export * from "./dataImport.vue?vue&type=script&lang=js&"
import style0 from "./dataImport.vue?vue&type=style&index=0&id=4bebcdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebcdac",
  null
  
)

export default component.exports